import React, { useState } from 'react'
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import copy from 'copy-to-clipboard'

import upVoteicon from '../../assets/upVoteicon.png'
import downVoteicon from '../../assets/downVoteicon.png'
import './Questions.css'
import Avatar from '../../components/Navbar/Avatar/Avatar'
import DisplayAnswer from './DisplayAnswer'
import { postAnswer, deleteQuestion, voteQuestion } from '../../actions/question'

const QuestionsDetails = () => {

    const { id } = useParams()
    const questionsList = useSelector(state => state.questionsReducer)
    // console.log(id)
    // var questionsList = [{
    //     _id: '1',
    //     upVotes: 3,
    //     downVotes: 2,
    //     noOfAnswers: 2,
    //     questionTitle: "What is a function?",
    //     questionBody: "It means that",
    //     questionTags: ["java", "node js", "react js", "mongodb"],
    //     userPosted: "nano",
    //     userId: 1,
    //     askedOn: "Jan 21", 
    //     answer: [{
    //       answerBody: "Answer",
    //       userAnswered: 'zaeden',
    //       answeredOn: "Jan 22",
    //       userId: 4,
    //     }]
    //   },{
    //     _id: '2',
    //     upVotes: 8,
    //     downVotes: 2,
    //     noOfAnswers: 0,
    //     questionTitle: "Can you develop AI using Python?",
    //     questionBody: "It means that",
    //     questionTags: ["javascript", "R", "python"],
    //     userPosted: "meta",
    //     userId: 2,
    //     askedOn: "July 30",
    //     answer: [{
    //       answerBody: "Answer",
    //       userAnswered: 'zayn',
    //       answeredOn: "Aug 2",
    //       userId: 5,
    //     }]
    //   },{
    //     _id: '3',
    //     upVotes: 12,
    //     downVotes: 0,
    //     noOfAnswers: 2,
    //     questionTitle: "What is the difference between JAVA, C and Python?",
    //     questionBody: "It means that",
    //     questionTags: ["java", "C", "python"],
    //     userPosted: "elon",
    //     userId: 3,
    //     askedOn: "Oct 6",
    //     answer: [{
    //       answerBody: "Answer",
    //       userAnswered: 'hammed',
    //       answeredOn: "Oct 22",
    //       userId: 6,
    //     }]
    //   }]
    const [Answer, setAnswer] = useState('')
    const Navigate = useNavigate()
    const dispatch= useDispatch()
    const User = useSelector((state) => (state.currentUserReducer))
    const location = useLocation()
    const url = 'https://hammedz-stack-overflow.netlify.app'

    const handlePostAns = (e, answerLength) => {
        e.preventDefault()
        if(User === null){
            alert('Login or Signup to answer a question')
            Navigate('/Auth')
        }else{
            if(Answer === ''){
                alert('Enter an answer before submitting!')
            }
            else{
                dispatch(postAnswer({ id, noOfAnswers: answerLength + 1, answerBody: Answer, userAnswered: User.result.name, userId: User.result._id }))
            }
        }
    }

    const handleShare = () => {
        copy(url+location.pathname)
        alert('Link has been copied to clipboard! Link:'+url+location.pathname)
    }

    const handleDelete = () => {
        dispatch(deleteQuestion(id, Navigate))
    }

    const handleUpVote = () => {
        dispatch(voteQuestion(id, 'upVote', User.result._id))
    }

    const handleDownVote = () => {
        dispatch(voteQuestion(id, 'downVote', User.result._id))
    }

  return (
    <div className='question-details-page'>
       {
        questionsList.data === null ?
        <h1>Loading...</h1> :
        <>
            {
                questionsList.data.filter(question => question._id === id).map(question => (
                    <div key={question._id}>
                        {console.log(question)}
                        <section className='question-details-container'>
                            <h1>{question.questionTitle}</h1>
                            <div className='question-details-container-2'>
                                <div className='question-votes'>
                                    <img src={upVoteicon} alt="" width='20' className='votes-icon' onClick={handleUpVote}/>
                                    <p>{question.upVote.length - question.downVote.length}</p>
                                    <img src={downVoteicon} alt="" width='20' className='votes-icon' onClick={handleDownVote}/>
                                </div>
                                <div style={{width: "100%"}}>
                                    <p className='question-body'>{question.questionBody}</p>
                                    <div className='question-details-tags'>
                                        {
                                            question.questionTags.map((tag) => (
                                                <p key={tag}>{tag}</p>
                                            ))
                                        }
                                    </div>
                                    <div className='question-actions-user'>
                                        <div>
                                            <button type='button' onClick={handleShare}>Share</button>
                                            {
                                                User.result._id === question.userId && (
                                                    <button type='button'onClick={handleDelete}>Delete</button>
                                                )
                                            }
                                        </div>
                                        <div>
                                            <p>Asked: {moment(question.askedOn).fromNow()}</p>
                                            <Link to={`/Users/${question.userId}`} className='user-link' style={{color:'white'}}>
                                                <Avatar backgroundColor="#e6792b" px='8px' py='5px'>{question.userPosted.charAt(0).toUpperCase()}</Avatar>
                                                <div>
                                                    {question.userPosted}
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {
                            question.noOfAnswers !== 0 && (
                                <section className='answer-section'>
                                    <h3>{question.noOfAnswers} Answers</h3>
                                    <DisplayAnswer key={question._id} question={question} handleShare={handleShare}/>
                                </section>
                            )
                        }

                        <section className='post-ans-container'>
                        <h3>Your Answer</h3>
                        <form onSubmit={ (e) => { handlePostAns(e, question.answer.length) }}>
                            <textarea name="" id="" cols="30" rows="10" onChange={e => setAnswer(e.target.value)}></textarea><br />
                            <input type="Submit" className='post-ans-btn' value='Post your Answer!'/>
                        </form>
                        <p>
                        Browser other Question tagged
                        {
                            question.questionTags.map((tag) => (
                                <Link to='/Tags' style={{textDecoration: "none", color:"white"}} key={tag} className='ans-tags'> {tag} </Link>
                            ))
                        } or
                        <Link to='/AskQuestion' style={{textDecoration: "none", color:"#ef8236"}}> ask your own question.</Link>
                        </p>
                        </section>

                    </div>
                ))
            }
        </>
       }
    </div>
  )
}

export default QuestionsDetails